<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    //
  })
};
</script>

<style>
* {
  font-family: "Spoqa Han Sans", "Spoqa Han Sans JP", "Sans-serif";
}
.bold-50 {
  font-size: 50px;
  font-weight: bold;
}
.bold-32 {
  font-size: 30px;
  font-weight: bold;
}
.bold-30 {
  font-size: 30px;
  font-weight: bold;
}
.bold-28 {
  font-size: 28px;
  font-weight: bold;
}
.bold-24 {
  font-size: 24px;
  font-weight: bold;
}
.bold-20 {
  font-size: 24px;
  font-weight: bold;
}
.bold-18 {
  font-size: 18px;
  font-weight: bold;
}
.bold-16 {
  font-size: 16px;
  font-weight: bold;
}
.regular-28 {
  font-size: 28px;
}
.regular-20 {
  font-size: 20px;
}
.regular-24 {
  font-size: 24px;
}
.regular-16 {
  font-size: 16px;
}
.regular-14 {
  font-size: 14px;
}
</style>
